<template>

  <v-card flat>
    <v-card-title>Call sheet upload</v-card-title>
    <uploader
      label="Now select callsheet pdf(s) to upload"
      :run-id="runId"
      :artwork-type-id="artworkTypeId"
      :artwork-comment="artworkComment"
      forceOriginal
      @error="uploadError"
      @done="uploadDone"
      @cancel="cancel"
      brief
    >
    </uploader>

  </v-card>

</template>

<script>
import Uploader from '@/components/Uploader'
import { createCallsheetsGql } from '@/js/mutations'
import { showToaster, mutate } from '@/js/apollo'
import { provokeCallsheetAnalysis } from '@/gql'
export default {
  data: () => ({
  }),
  props: {
    runId: String,
    artworkTypeId: String,
    artworkComment: String,
    filmId: String,
    master: Object
  },
  computed: {
    filmMasterID () {
      return this.master && this.master.id
    }
  },
  components: {
    uploader: Uploader
  },
  methods: {
    provokeAnalysis ({item}) {
      return mutate({
        mutation: provokeCallsheetAnalysis,
        variables: {
          input: {
            callsheetID: item.id
          }
        }
      })
    },
    cancel () {
      this.$emit('cancel')
    },
    uploadDone ({ files }) {
      // now create call sheet(s)

      return createCallsheetsGql ({
        apolloClient: this.$apollo,
        files,
        runID: this.runId,
        filmMasterID: this.filmMasterID
      })
      .then (callsheets => {
        // provoke analysis of uploaded callsheets
        return Promise.all(callsheets.map(item => {
          return this.provokeAnalysis({
            item
          })
        }))
        .then(() => this.$emit('done', { callsheets }))
      })

    },
    uploadError ({ error }) {
      showToaster({
        header: 'upload failure',
        type: 'error',
        message: 'failed to upload callsheet',
        error
      })
    }
  }
}
</script>
